<template>
    <van-dialog
            v-model="show"
            :title="title"
            show-cancel-button
            :before-close="auditConfirm"
            @cancel="auditRiskHeadShow=false"
    >
        <van-field name="radio" label="渠道配资">
            <template #input>
                <van-radio-group v-model="fundingFlag" direction="horizontal">
                    <van-radio name="true">是</van-radio>
                    <van-radio name="false">否</van-radio>
                </van-radio-group>
            </template>
        </van-field>
        <van-field label="配资金额" v-if="fundingFlag==='true'" type="number" v-model="fundingAmount" :error-message="fundingAmountErr"
                   placeholder="请输入"/>
        <van-field name="radio" label="是否标准单">
            <template #input>
                <van-radio-group v-model="standardFlag" direction="horizontal">
                    <van-radio name="true">是</van-radio>
                    <van-radio name="false">否</van-radio>
                </van-radio-group>
            </template>
        </van-field>
        <van-field type="textarea" size="large" v-model="remark" :error-message="remarkErr" placeholder="请输入审批意见"/>
    </van-dialog>
</template>

<script>
    import { auditProcess } from '@/api/loanInfo'
    import { eventBus} from '../../../../../vue/utils/eventBus'
    import { mapGetters} from 'vuex'

    export default {
        name: 'head_audit_dialog',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        watch: {
            'remark'(val) {
                if (val == undefined || val.length > 0) {
                    this.remarkErr = ''
                }
            },
            'fundingAmount'(val) {
                if (val == undefined || val.length > 0) {
                    this.fundingAmountErr = ''
                }
            }
        },
        components: {},
        computed: mapGetters([
            'auditStatus',
            'applyInfo',
            'userName',
            'name'
        ]),
        data() {
            return {
                show: false,
                fundingFlag:'false',
                fundingAmount: '',
                fundingAmountErr: '',
                standardFlag:'false',
                remark: '',
                remarkErr: '',
                type: 'pass',
                process: 'ASSISTANT_FIRST_TRIAL',
                title: '橙易贷专员审批'
            }
        },
        mounted() {
            let self = this
            //审批
            eventBus.$on('assistant-first-trial-dialog', function (data) {
                self.show = true
            })

        },
        destroyed() {
            eventBus.$off('assistant-first-trial-dialog')
        },
        methods: {
            auditConfirm(action, done) {
                console.log('confirm')
                if (action === 'confirm') {

                    let flag = false

                    //验证
                    if (this.fundingFlag == 'true' && !this.fundingAmount) {
                        this.fundingAmountErr = '请输入配资金额'
                        flag = true
                    }


                    if (!this.remark) {
                        this.remarkErr = '请输入审批意见'
                        flag = true
                    }

                    if(flag) {
                        done(false)
                        return false
                    }

                    let params = {
                        process: this.process,
                        applyId: this.applyId,
                        type: this.type,
                        remark: this.remark,
                        standardFlag: this.standardFlag,
                        fundingFlag: this.fundingFlag,
                        fundingAmount:this.fundingAmount
                    }

                    auditProcess(params).then(res => {
                        done()
                        this.$toast(res.msg)
                        if (res.success) {
                            this.$router.go(-1)
                        }
                    })
                } else {
                    this.remarkErr = ''
                    done()
                }

            }

        }
    }
</script>

<style scoped>

</style>


